import React from 'react'
import "./Whatsapp.css"
import { FaWhatsapp } from "react-icons/fa";

const Whatsapp = () => {




  const phoneNumber = "9646555699";
  const message = "Hi, I'm interested in your services";

  return (
    <a
      href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-badge"
    >
      <FaWhatsapp size={30} color="white" />
    </a>
  );
}

export default Whatsapp